<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      fullscreen
      class="dialog"
    >
      <el-card>
        <el-form :model="filter" class="filer" size="small" label-width="100px" inline>
          <el-form-item label="销售姓名：">
            <el-input v-model="filter.saleName" maxlength="20" placeholder="请输入销售姓名" />
          </el-form-item>
          <el-form-item label="销售手机号：">
            <el-input v-model="filter.salePhone" maxlength="11" placeholder="请输入销售手机号" />
          </el-form-item>
          <el-form-item label="数据时间：">
            <el-date-picker
              v-model="dateList"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="primary" @click="handleExport">导出</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card style="margin-top: 10px;">
        <el-table
          v-loading="loading"
          :data="list"
          border size="small"
        >
          <el-table-column align="center" label="企微账号" prop="qwAccount" min-width="120px" />
          <el-table-column align="center" label="销售姓名" prop="saleName" min-width="100px" />
          <el-table-column align="center" label="销售手机号" prop="salePhone" min-width="110px" />
          <el-table-column align="center" label="新增客户数" prop="incrContactCnt" min-width="100px" />
          <el-table-column align="center" label="新增被拉黑/删除数" prop="incrNegativeFeedbackCnt" min-width="130px" />
          <el-table-column align="center" label="新增聊天数" prop="incrChatCnt" min-width="100px" />
          <el-table-column align="center" label="平均首次回复时长" prop="avgReplyTime" min-width="140px" />
          <el-table-column align="center" label="发起申请数" prop="newApplyCnt" min-width="100px" />
          <el-table-column align="center" label="已回复聊天占比" min-width="120px">
            <template v-slot="{ row }">
              <span>{{ row.replyPercentage + '%' }}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          style="margin-top: 10px; text-align: center;"
          :current-page="filter.page"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="filter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        /> -->
      </el-card>
      <!-- 导出 -->
    </el-dialog>
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import FileExport from '@/components/FileExport'
import { getStatisticsList } from '@/api/admin/saleQrcode.js'

export default {
  name: 'Statistics',

  components: { FileExport },
  data() {
    return {
      dialogVisible: false,
      title: '',
      liveCodeId: '',
      filter: {
        page: 1,
        limit: 10,
        saleName: '',
        salePhone: '',
        start: '',
        end: ''
      },
      loading: false,
      list: [],
      // total: 0
    }
  },
  computed: {
    dateList: {
      get() {
        return [this.filter.start, this.filter.end]
      },
      set(v) {
        if (v && v.length) {
          this.filter.start = v[0] + ' 00:00:00' || ''
          this.filter.end = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.start = ''
          this.filter.end = ''
        }
      }
    }
  },
  methods: {
    init(v) {
      this.title = v.name
      this.liveCodeId = v.id
      this.getList()
      this.dialogVisible = true
    },
    handleSearch() {
      this.filter.page = 1
      this.getList()
    },
    getList() {
      this.loading = true
      const params = {
        ...this.filter,
        liveCodeId: this.liveCodeId
      }
      getStatisticsList(params).then(({ code, data }) => {
        if (code === 0) {
          this.list = data
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 300)
      })
    },
    handleReset() {
      this.filter = this.$options.data().filter
      this.getList()
    },
    // 导出
    handleExport() {
      const filter = { ...this.filter, liveCodeId: this.liveCodeId }
      delete filter.page
      delete filter.limit
      this.$refs.FileExport.init(
        filter,
        'jsw-qw-provider',
        '/adm/qwLiveCodeData/exportData',
        1,
        '销售活码统计.xlsx'
      )
    },
    handleClose() {
      this.title = ''
      this.filter = this.$options.data().filter
      this.dialogVisible = false
    },
    // handleSizeChange(v) {
    //   this.filter.page = 1
    //   this.filter.limit = v
    //   this.getList()
    // },
    // handleCurrentChange(v) {
    //   this.filter.page = v
    //   this.getList()
    // },
  }
}
</script>

<style lang="scss" scoped>

</style>
